import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withCtx as _withCtx, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-25d2f0cd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "footer xag-page__footer nongfu-button-wrap" }
const _hoisted_2 = { class: "tips-confirm" }
const _hoisted_3 = { class: "check-content" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "已阅读并同意", -1))
const _hoisted_5 = ["onClick"]

import { useStore } from 'vuex'
import { Button, Checkbox } from 'vant'
import { useRouter, Router } from 'vue-router'
import appHost from '@/utils/app'
import AppHeader from '@/components/Header.vue'
import CommonContent from './components/common-content.vue'


import { defineComponent } from 'vue'

const __default__ = defineComponent({
  name: 'close-account-apply',
})

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const store = useStore()
const $router: Router = useRouter()
// const agree = ref(store.state?.CloseAccount?.agree || false)
const CloseAccountState = store.state.CloseAccount
const content = {
  title: '申请注销极飞账号',
  description: '在您提交注销申请前，请确保您的极飞账号同时满足以下条件，我们将对此进行审核：',
  infoList: [
    {
      label: '1. 账号处于安全状态',
      value: '您的账号处于正常使用状态，无被盗风险。',
    },
    {
      label: '2. 账户财产已经结清',
      value:
        '没有资产、欠款、未结清的资金并自愿放弃未使用完毕的虚拟权益，本账号及通过本账号接入的第三方中没有未完成或存在争议的服务。',
    },
    {
      label: '3. 账号名下极飞设备已经解绑',
      value: '该账号已经解除和所有极飞设备的绑定关系。',
    },
    {
      label: '4. 账号名下单据已经完结',
      value: '您的账号没有未完成的保障单、售后服务单、商城订单、第三方服务单据等。',
    },
  ],
}
function onLeftClick() {
  appHost.goAppBack()
}
function checkCloseAccountNotice() {
  $router.push({
    path: '/protoc',
    query: {
      title: '注销须知',
      url: 'https://app.xag.cn/help_doc/b4e4e12d-bd82-40fc-a291-4ae3ed8cb20d',
    },
  })
}
function toSmsVerify() {
  $router.push({
    name: 'close-account-sms-verify',
  })
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, {
      title: "注销账号",
      isReturnLeftEvent: "",
      onLeftClick: onLeftClick,
      class: "default-bg"
    }),
    _createVNode(CommonContent, {
      data: content,
      class: "default-bg"
    }),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Checkbox), {
          modelValue: _unref(CloseAccountState).agree,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(CloseAccountState).agree) = $event)),
          shape: "square",
          class: "xa-vant-checkbox",
          "icon-size": "14px"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_3, [
              _hoisted_4,
              _createElementVNode("span", {
                onClick: _withModifiers(checkCloseAccountNotice, ["stop"])
              }, "《注销须知》", 8, _hoisted_5)
            ])
          ]),
          _: 1
        }, 8, ["modelValue"])
      ]),
      _createVNode(_unref(Button), {
        type: "success",
        onClick: toSmsVerify,
        block: "",
        round: "",
        class: "button xa-vant-button",
        disabled: !_unref(CloseAccountState).agree
      }, {
        default: _withCtx(() => [
          _createTextVNode("申请注销")
        ]),
        _: 1
      }, 8, ["disabled"])
    ])
  ], 64))
}
}

})